import { appRoutes } from 'features/app/routes/paths';

export const orderHistoryPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/order-history`,
  },
});
